<template>
  <v-container
    id="about"
    tag="section"
  >
    <base-subheading><h1 class="text-center mt-5" style="font-family: 'Montserrat Subrayada', sans-serif;">ELECTRIC RECHARGING POINT</h1></base-subheading>
    <v-col cols="10" offset-md="1">

      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Carporty to nowoczesne wiaty garażowe wyposażone w panele fotowoltaiczne, które tworzą ekologiczną przestrzeń parkingową. Wolnostojąca wiata fotowoltaiczna określana jest zamiennie wiatą solarną lub carportem. To innowacyjne rozwiązanie wyposażone najczęściej w klasyczną stację ładowania pojazdów. Solarna wiata samochodowa umożliwi również skuteczne zabezpieczenie pojazdu przed szkodliwym wpływem opadów deszczu lub śniegu.
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Nasze carporty charakteryzują się dużą wytrzymałością i nowoczesnym designem, a jednocześnie umożliwiają ładowanie samochodu elektrycznego w domu. Wiaty PV wykonane są z ocynkowanej stali lub z drewna.
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;"><i> 
        </i>
      </p>

    </v-col>
    <base-subheading><h1 class="text-center mt-5" style="font-family: 'Montserrat Subrayada', sans-serif;">electric vehicle supply equipment (EVSE)</h1></base-subheading>
  </v-container>
</template>

<script>
  export default {
    name: 'HomeAbout',
  }
</script>
